import { render } from "./password-modal.vue?vue&type=template&id=0792599e&scoped=true"
import script from "./password-modal.vue?vue&type=script&lang=js"
export * from "./password-modal.vue?vue&type=script&lang=js"

import "./password-modal.vue?vue&type=style&index=0&id=0792599e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0792599e"]])

export default __exports__